export default __webpack_public_path__ + "static/media/pic1.ddc2243a.jpg";